module.exports = __webpack_public_path__ + "img/illu-tray-sm.0efeebca.svg";